import React, { useContext } from "react";
import { StyledIconButton } from "../styled";
import { Box, Checkbox, FormControlLabel, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, LinkOff } from "@mui/icons-material";
import {
  DeviceModelTab,
  ReducerContext,
  ReducerDispatchContext,
} from "@pages/Configuration/DeviceCatalog/context";

const MappingInfo = () => {
  const {
    accountId,
    mappingInherit,
    propertyMappingEnabled,
    canEdit,
    canAccessExtendedPropertyMapping,
  } = useContext(ReducerContext);
  const dispatch = useContext(ReducerDispatchContext);
  const { t } = useTranslation();

  const canEditToggle = canEdit && canAccessExtendedPropertyMapping;

  return (
    <Stack direction="row">
      {accountId && (
        <Box
          sx={{
            height: "max-content",
          }}
        >
          <Tooltip
            title={
              mappingInherit ? t("Value is inherited") : t("Value is custom")
            }
            arrow
          >
            <span>
              <StyledIconButton
                disabled={!canEditToggle}
                color="inherit"
                onClick={() => dispatch({ type: "toggleMappingInherit" })}
              >
                {mappingInherit ? <Link /> : <LinkOff />}
              </StyledIconButton>
            </span>
          </Tooltip>
        </Box>
      )}
      <Tooltip
        title={
          accountId && !canAccessExtendedPropertyMapping
            ? t("Available in higher-tier licenses")
            : ""
        }
        arrow
      >
        <span>
          <FormControlLabel
            control={
              <Checkbox
                disabled={!canEditToggle || !!(accountId && mappingInherit)}
                checked={propertyMappingEnabled}
                onChange={(_, checked) => {
                  dispatch({
                    propertyMappingEnabled: checked,
                    isDataChanged: true,
                    ...(checked
                      ? { tabSelected: DeviceModelTab.MAPPING }
                      : undefined),
                  });
                }}
              />
            }
            label={t("Enable Property Mapping")}
          />
        </span>
      </Tooltip>
    </Stack>
  );
};

export default MappingInfo;
